import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'pips'
})
export class PipsPipe implements PipeTransform {

  transform(val: any, model: any, ci: number): any {
    if (val == null) return null
    let col = model.cols[ci]
    if (!col.pip)
      if (col.vals == 'status') return this.statu(model, val)
      else return val

    let pip = col.pip.split('ö')
    let res
    switch (pip[0]) {
      case 'amount': return this.amount(val)
      case 'yesno': return this.yesno(val)
      case 'date': return this.date(val, '-')
      case 'time': return this.time(val)
      case 'datetime': return this.datetime(val)
      case 'minute': return this.minute(val)
      case 'tel': return this.tel(val)
      case 'mobile': return this.mobile(val)
      case 'month': return this.month(val)
      case 'password': return this.password(val)
      case 'account': return this.separate(val, '-', 3)
      case 'iban': return this.separate(val, '-', 4)
      case 'tafsil': return this.tafsil(val)
      case 'percent': return this.percent(val)
      case 'json': return this.json(val)
      case 'reverse': return this.reverse(val.toString())

      default: eval('res = ' + col.pip); return res
    }
  }

  reverse(str: string) {
    var nstr = "";
    for (var i = str.length - 1; i >= 0; i--)
      nstr += str[i];
    return nstr;
  }
  separate = (val: any, char: string, length: number) => {
    val = val.match(new RegExp('.{1,' + length + '}', 'g')).join(char)
    return val
  }
  amount = (val: any) => { return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }
  date = (val: number, char?: string) => {
    if (char == undefined) char = ''

    let sval = val + ''
    if (sval.length == 8)
      return sval.substr(0, 4) + char + sval.substr(4, 2) + char + sval.substr(6)
    if (sval.length == 6)
      return sval.substr(0, 2) + char + sval.substr(2, 2) + char + sval.substr(4)
    return val
  }
  idtodate = (val: string, char?: string, with_second?: boolean) => {
    if (!char) char = '-'
    if (val.length < 15) return val
    return (with_second ? val.substr(8, 2) + ':' + val.substr(10, 2) + ' ' : '') + val.substr(0, 4) + char + val.substr(4, 2) + char + val.substr(6, 2)
  }
  padStart = (val: string, len: number, char?: string) => {
    if (!val) return val
    if (!char) char = '0'
    for (let i = val.length; i < len; i++)
      val = char + val
    return val
  }
  time = (val: any, sec?: boolean, char?: string) => {
    if (!char) char = ':'
    if (!sec) sec = false
    if (!parseInt(val)) return val
    val = parseInt(val)
    let sign = ''
    if (val < 0) {
      sign = '-'
      val = val * -1
    }

    let h = Math.floor(val / 3600)
    let m = Math.floor((val - (h * 3600)) / 60)
    let s = val - (h * 3600 + m * 60)
    if (!sec) return sign + this.padStart(h + '', 2) + char + this.padStart(m + '', 2)
    else return sign + this.padStart(h + '', 2) + char + this.padStart(m + '', 2) + char + this.padStart(s + '', 2)
  }
  minute = (val: number) => { return this.padStart((val / 60) + '', 2) + ':' + this.padStart((val - (val / 60 * 60)) + '', 2) }
  datetime = (val: any) => { return val + ' datetime' }
  month = (val: number) => { return val }
  tel = (val: any) => { return '0' + val.substr(0, 2) + '-' + val.substr(2) }
  mobile = (val: any) => { return '0' + val.substr(0, 3) + '-' + val.substr(3) }
  statu = (model: any, val: any) => {
    for (let stu of model.stus)
      if (stu.lev == val)
        return stu.tit
    return val
  }
  yesno = (val: any, _rev?: boolean) => {
    let y = (_rev ? 'خیر' : 'بلی')
    let n = (_rev ? 'بلی' : 'خیر')

    if (val == '0' || val == 0) return n
    if ([false, 'false', 'FALSE', 'no', 'NO', 'off', 'OFF', 0, '0'].find(x => x == val)) return n;
    if ([true, 'true', 'TRUE', 'yes', 'YES', 'on', 'ON', 1, '1'].find(x => x == val)) return y;
    return val ? y : n
  }
  password = (val: any) => {
    return '****'
  }
  slice = (val: string, char: string, i: number) => {
    return val.split(char)[i]
  }
  qlist = (val: any, cnf: { opts: any[], vie: boolean }) => {
    let t = cnf.opts.find(x => x[0] == val)
    if (!t) return 'نا معتبر'
    if (t.length > 1 && (cnf.vie || cnf.vie == undefined)) return t[1]
    if (t.length == 1) return t[0]
    return val
  }
  tafsil = (val: string) => {
    return '5-0' + val.substr(0, 1) + '-' + val.substr(1)
  }
  substr = (val: string, from: number, length: number) => {
    return val.substr(from, length)
  }
  split_index = (val: string, char: string, index: number) => {
    let v = val.split(char)
    return v.length > index ? v[index] : null
  }
  percent = (val: string) => {
    return val + '%'
  }
  json = (val: any) => {
    return JSON.stringify(val)
  }
}